const elasticsearch = require("elasticsearch");

/**
 * Initialize and return a new Elasticsearch client
 *
 * @param  {Object} configuration  Elasticsearch client configuration
 *
 * @return     {Function}  An Elasticsearch API client object.
 */
export const getClient = ({ host, pass, port, protocol, user }) => {
  return new elasticsearch.Client({
    host: `${protocol}://${user}:${pass}@${host}:${port}`
  });
};
